module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/programs@2x-87928b306e7ca9597ade238e58c503d9.jpg";